import React from "react"
import styles from "./styles.scss"

class About extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <h1>Lägg till ditt företag på Fixarfolket.se</h1>
          <p>
            Det är gratis att lägga till sitt företag på Fixarfolket. Med
            hjälp av Fixarfolket upptäcker folk ditt företag och era
            tjänster.
          </p>
        </div>
        <div className={styles.drillingMan} />
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// src/pages/InfoPage/About/index.jsx